module.exports = __webpack_public_path__ + "img/segurossura.3842a1cc.png";